/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-mixed-spaces-and-tabs */
import React, { cloneElement, useCallback, useEffect, useRef, useState } from 'react';
import {
	MRT_ColumnDef,
	MRT_ColumnSizingInfoState,
	MRT_ColumnSizingState,
	MRT_Header,
	MRT_Row,
	MRT_RowData,
	MRT_RowSelectionState,
	MRT_SortingState,
	MRT_TableInstance,
	MRT_TableState,
	MaterialReactTable,
	MaterialReactTableProps,
	useMaterialReactTable,
	// Cell
} from 'material-react-table';
import { IPaginationModel } from '../../@types/pagination-model';
import {
	Box,
	styled,
	MenuItem,
	IconButton,
	ListItemIcon,
	ListItemText,
	SvgIconProps,
	Divider
} from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import Menu from '../menu/menu';
import Typography from '../typography/typography';
import SearchBar from '../search-bar/search-bar';
import images from '../../assets/images';
// import DeleteIcon from "@mui/icons-material/Delete";
// import UpdateIcon from "@mui/icons-material/Update";
// import PlayIcon from "@mui/icons-material/PlayArrow";

import './material-editable-table.scss';
import {
	ArrowUpDown,
	CheckBoxIcon,
	Close,
	RecgtangleIcon,
	Trash,
	Save
} from '../icons';
// import {
// 	ArrowDropDown /* , SaveOutlined */,
// 	ArrowDropUp
// } from '@mui/icons-material';
import InlineEditFields from './components/inline-edit-fields';
import Tooltip from '../tooltip/Tooltip';
import Button from '../button/button';
import Add from '@mui/icons-material/Add';
import dayjs from 'dayjs';
import * as yup from 'yup';
import ConfirmPopUp from '../confirm-modal/confirm-modal';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';
import { getErrorMessage } from '../../utils/common';
import { usePages } from '@erpsquad/common/runtime';
import { useNavigate } from 'react-router-dom';
// import { PathnameAccounting } from 'accounting/src/pathname.accounting';
// import { PathnameInventory } from 'inventory/src/pathname.inventory';
// import { PathnameManufacturing } from 'manufacturing/src/pathname.manufacturing';
// import { PathnamePurchase } from 'procurement/src/pathname.procurement';
// import { PathnameCrm } from 'crm/src/pathname.crm';
// import { PathnameUsers } from '../../constants/pathnames/pathname.user';
// import { PathnameRental } from '../../../../rental/src/pathname.rental';
// import { PathnameDocument } from 'document/src/pathname.document';
import { PathnameDocument } from '../../constants/pathnames/pathname.document';
import { PathnameAccounting } from '../../constants/pathnames/pathname.accounting';
import { PathnameInventory } from '../../constants/pathnames/pathname.inventory';
import { PathnameManufacturing } from '../../constants/pathnames/pathname.manufacturing';
import { PathnamePurchase } from '../../constants/pathnames/pathname.procurement';
import { PathnameCrm } from '../../constants/pathnames/pathname.crm';
import { PathnameUsers } from '../../constants/pathnames/pathname.user';
import { PathnameRental } from '../../constants/pathnames/pathname.rental';
import useDeepMemo from '../../hooks/use-deep-memo';
import { PageState } from '@erpsquad/common/runtime';

type ExtraEditVariants =
	| 'file'
	| 'image'
	| 'date'
	| 'number'
	| 'time'
	| 'date_time'
	| 'phone'
	| 'checkbox';

type DisableFunction = (row: any, virtualRow?: any) => boolean;

export type TypeBooleanLabels = { 1: string; 0: string; true: string; false: string }

export interface MaterialEditableTableColumnProps
	extends Omit<MRT_ColumnDef<MRT_RowData>, 'editVariant'> {
	visible?: boolean;
	type?: string;
	showDefaultCurrency?: boolean,
	valueGet?: string;
	custom_class?: string;
	typeArrayAccessorKey?: string; //when type is an array of object
	typeBooleanLabels?: TypeBooleanLabels; //when type is an boolean
	editVariant?: MRT_ColumnDef<MRT_RowData>['editVariant'] | ExtraEditVariants;
	editProperties?: {
		field_name?: string;
		valueKey?: string;
		placeholder?: string;
		dateFormat?: string;
		validations?: any[];
		is_multiple?: boolean;
		is_multiline?: boolean;
		disable?: boolean | DisableFunction;
		min_date?: any;
		max_date?: any;
	};
	redirectionPathWithId?: string;
	idField?: string;
	isOnClickEditable?: boolean; // Controls whether clicking this column triggers row edit mode (default: true)
}



export interface MaterialEditableTableColumnHeaderProps {
	column: MRT_ColumnDef<any, any>;
	header: MRT_Header<any>;
	table: MRT_TableInstance<any>;
}

type rowSelectionCallback = (row: MRT_Row) => boolean

interface MaterialEditableTablePropsType {
	enablePagination?: boolean;
	rows: any;
	totalPages: number;
	columns: any;
	paginationModel: IPaginationModel;
	columnOrder?: string[];
	updateData?: any;
	handleColumnOrdering?: (colOrder: any) => void;
	enableEditing?: boolean;
	enableColumnDragging?: boolean;
	rowActionMenu?: any;
	destructiveActionMenu?: any;
	getRowId?: any;
	states?: Partial<MRT_TableState<any>>;
	onSortingChange?: any;
	disableDefaultActionColumn?: boolean;
	enableRowSelection?: boolean | rowSelectionCallback;
	defaultActionColumnItems?: React.ReactElement[];
	enableBottomToolbar?: boolean;
	SetSelectedRowId?: any;
	isResetRow?: boolean;
	onCreateRow?: (data: any) => Promise<unknown>;
	onEditRow?: (data: any) => Promise<unknown>;
	onDeleteRow?: (data: any) => Promise<unknown>;
	editDisplayMode?: MaterialReactTableProps<any>['editDisplayMode'];
	enableRowCreate?: boolean;
	onChangeRowField?: (e: any, type: string, row: any) => void;
	onSelectRow?: (rows: any, prevSelected?: any) => any;
	enableColumnResizing?: boolean;
	selectedRowIds?: any[];
	onColumnVisibility?: (columns: MaterialTableColumnProps[]) => void
	getSelectedData: any;
	enableAddCustomField?: boolean;
	disabledDefaultActionColumnIcon?: boolean
	enableRowDragging?: boolean
	handleColumnResizing?: (sizes: MRT_ColumnSizingState) => void,
	columnSizes?: MRT_ColumnSizingState,
	hideSaveButton?: boolean;
	hideDeleteButton?: (row: any) => boolean;
	enableFirstRowEdit?: boolean;
}

const TableWrapper = styled(Box)(({ theme: { palette } }) => ({
	'.MuiTableCell-root': {
		border: '1px solid #efefef',
		borderBottom: 0,
		borderLeft: 0,
		padding: '0 0.5rem',
		lineHeight: '19px',
		fontSize: '14px',
		minHeight: 32,
		// '&:first-child': {
		// 	borderLeft: '1px solid #efefef'
		// },
		// '&:last-child': {
		// 	borderBottom: '1px solid #efefef'
		// }

	},
	'.MuiTableCell-head': {
		backgroundColor: palette.theme?.secondary[100]
	},
	'.MuiTableContainer-root': {
		maxHeight: 'clamp(350px, 100vh - 200px, 9999px) !important',
	},

	'.MuiPaper-root': {
		boxShadow: 'none',

	},
	'.MuiPaginationItem-root': {
		'&.Mui-selected': {
			backgroundColor: palette?.theme?.primary[700],
			color: 'white'
		}
	},
	'.MuiTableRow-root': {
		'&.Mui-selected': {
			backgroundColor: `${palette?.theme?.primary[100]} !important`,
			color: 'white'
		}
	},
	'.MuiCheckbox-indeterminate': {
		color: `${palette?.theme?.primary[700]} !important`,
		"& svg": {
			height: `20px !important`,
			width: `20px !important`,
		}
	}
}));

export type RowValues = Record<string, unknown>;

const MaterialEditableTable = React.memo(({
	enablePagination = false,
	rows,
	columns,
	totalPages,
	paginationModel,
	columnOrder,
	updateData,
	handleColumnOrdering,
	enableEditing,
	enableColumnDragging,
	states,
	rowActionMenu,
	destructiveActionMenu,
	disableDefaultActionColumn,
	enableRowSelection,
	defaultActionColumnItems = [],
	enableBottomToolbar,
	SetSelectedRowId,
	isResetRow,
	onCreateRow,
	onEditRow,
	onDeleteRow,
	editDisplayMode,
	enableRowCreate,
	onChangeRowField,
	onSelectRow,
	enableColumnResizing = true,
	selectedRowIds = [],
	onColumnVisibility,
	onSortingChange,
	getSelectedData,
	disabledDefaultActionColumnIcon = false,
	enableAddCustomField = true,
	enableRowDragging = false,
	handleColumnResizing = () => { },
	columnSizes = {},
	hideSaveButton = false,
	hideDeleteButton,
	enableFirstRowEdit = false,
	// eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars
	// getRowId,
	// onDelete,
	// onUpdate,
	...rest
}: MaterialTablePropsType) => {
	const { t } = useTranslation();
	const { enqueueSnackbar } = useSnackbar();
	const { formData = null, updatePageInfo, activePage: aPage } = usePages()
	const activePage = useDeepMemo<PageState>(aPage);
	const { pageNo } = paginationModel;
	const [row, setRow] = useState({});
	const [tableColumns, setTableColumns] = useState(columns);
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const [popUpShow, setPopupShow] = useState<boolean>(false);
	const [rowAnchorEl, setRowAnchorEl] = useState<null | HTMLElement>(null);
	const visibleColumns = tableColumns.filter((column: any) => column.visible);
	const hiddenColumns = tableColumns.filter((column: any) => !column.visible);
	const [filteredOptions, setFilteredOptions] = useState(hiddenColumns);
	const [selectedRow, setSelectedRow] = useState<number | null>(null);
	const [validationErrors, setValidationErrors] = useState<Record<string, Record<string, string>>>({});
	const [validationSchema, setValidationSchema] = useState<any>([]);
	const [isCreatingRow, setIsCreatingRow] = useState<boolean>(false);
	const [isEditingRow, setIsEditingRow] = useState<boolean>(false);
	const [isDeletingRow, setIsDeletingRow] = useState<boolean>(false);
	const [rowToDelete, setRowToDelete] = useState<any>(null);
	const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
	const [isChecked, setIsChecked] = useState(false)
	const [sorting, setSorting] = useState<MRT_SortingState>([]);
	const [disableNextEdit, setDisableNextEdit] = useState(false);
	const [columnSizing, setColumnSizing] = useState<MRT_ColumnSizingState>(activePage.column_sizes);
	const [columnSizingInfo, setColumnSizingInfo] = useState<MRT_ColumnSizingInfoState>({
		columnSizingStart: [],
		deltaOffset: null,
		deltaPercentage: null,
		isResizingColumn: false,
		startOffset: null,
		startSize: null
	});
	const [clickStartTime, setClickStartTime] = useState<number>(0);

	const navigate = useNavigate();
	const currentModule = location.pathname.split('/')[2]

	let redirectionPath = ''
	switch (currentModule) {
		case 'accounting':
			redirectionPath = PathnameAccounting.CUSTOM_FORM
			break;
		case 'inventory':
			redirectionPath = PathnameInventory.CUSTOM_FORM
			break;
		case 'manufacturing':

			redirectionPath = PathnameManufacturing.CUSTOM_FORM
			break;
		case 'procurement':
			redirectionPath = PathnamePurchase.CUSTOM_FORM
			break;
		case 'crm':
			redirectionPath = PathnameCrm.CUSTOM_FORM
			break;
		case 'user':
			redirectionPath = PathnameUsers.CUSTOM_FORM
			break;
		case 'rental':
			redirectionPath = PathnameRental.CUSTOM_FORM
			break;
		case 'drive':
			redirectionPath = PathnameDocument.ADD_CUSTOM_FIELDS
			break;
	}
	const path = `/dashboard/${currentModule}${redirectionPath}`
	const getValidationType = (column: any) => {
		switch (column.editVariant) {
			case 'select':
				return column?.editProperties?.is_multiple ? yup.array() : yup.string();

			case 'number':
				return yup.number().nullable().transform((value, originalValue) => (originalValue === "" ? null : value));

			case 'url':
				return yup
					.string()
					.matches(
						/^(https?:\/\/)?((([a-zA-Z0-9_-]+\.)+[a-zA-Z]{2,})|localhost)(:\d{2,5})?(\/[a-zA-Z0-9#_-]+\/?)*(\?[a-zA-Z0-9&=_-]+)?(#\S+)?$/,
						{ excludeEmptyString: true, message: 'Please enter valid URL.' }
					);

			case 'date':
			case 'date_time':
			case 'time':
				return yup.date().nullable().transform((value, originalValue) => {
					if (originalValue === "" || originalValue === null || originalValue === undefined) {
						return null;
					}
					if (originalValue && typeof originalValue === 'object' && 'toDate' in originalValue) {
						return (originalValue as any).toDate();
					}
					return value;
				}).typeError('Valid date is required');

			case 'file':
			case 'image':
				return yup.mixed().nullable();

			default:
				return yup.string()
		}
	};

	const validationReducer = (
		schema: any,
		validation: any,
		column: any
	) => {
		let vld = schema;

		switch (validation.type) {
			/* =====================================================
			   COMMON (mixed)
			===================================================== */

			case 'required':
				if (validation.value) {
					vld = vld.required(validation.msg_en).typeError(validation.msg_en);

					// Prevent blank-only string
					if (!column?.editVariant || column?.editVariant === 'text') {
						vld = vld.test(
							'no-blank-spaces',
							'Blank space is not allowed',
							(value: any) =>
								typeof value === 'string'
									? value.trim().length > 0
									: true
						);
					}
				} else if (column?.editProperties?.is_multiple) {
					vld = vld.min(1, validation.msg_en);
				}
				break;

			case 'notRequired':
				vld = vld.notRequired();
				break;

			case 'nullable':
				vld = vld.nullable(validation.value ?? true);
				break;

			case 'defined':
				vld = vld.defined(validation.msg_en);
				break;

			case 'optional':
				vld = vld.optional();
				break;

			case 'strict':
				vld = vld.strict(validation.value ?? true);
				break;

			case 'typeError':
				vld = vld.typeError(validation.msg_en);
				break;

			case 'oneOf':
				vld = vld.oneOf(validation.values, validation.msg_en);
				break;

			case 'notOneOf':
				vld = vld.notOneOf(validation.values, validation.msg_en);
				break;

			case 'default':
				vld = vld.default(validation.value);
				break;

			case 'transform':
				vld = vld.transform(validation.fn);
				break;

			case 'label':
				vld = vld.label(validation.value);
				break;

			case 'meta':
				vld = vld.meta(validation.value);
				break;

			/* =====================================================
			   STRING
			===================================================== */

			case 'trim':
				vld = vld.trim();
				break;

			case 'lowercase':
				vld = vld.lowercase();
				break;

			case 'uppercase':
				vld = vld.uppercase();
				break;

			case 'email':
				vld = vld.email(validation.msg_en);
				break;

			case 'url':
				vld = vld.url(validation.msg_en);
				break;

			case 'uuid':
				vld = vld.uuid(validation.msg_en);
				break;

			case 'length':
				vld = vld.length(validation.value, validation.msg_en);
				break;

			case 'min':
				vld = vld.min(validation.value, validation.msg_en);
				break;

			case 'max':
				vld = vld.max(validation.value, validation.msg_en);
				break;

			case 'matches':
				vld = vld.matches(validation.regex, validation.msg_en);
				break;

			case 'startsWith':
				vld = vld.matches(
					new RegExp(`^${validation.value}`),
					validation.msg_en
				);
				break;

			case 'endsWith':
				vld = vld.matches(
					new RegExp(`${validation.value}$`),
					validation.msg_en
				);
				break;

			/* =====================================================
			   NUMBER
			===================================================== */

			case 'lessThan':
				vld = vld.lessThan(validation.value, validation.msg_en);
				break;

			case 'moreThan':
				vld = vld.moreThan(validation.value, validation.msg_en);
				break;

			case 'positive':
				vld = vld.positive(validation.msg_en);
				break;

			case 'negative':
				vld = vld.negative(validation.msg_en);
				break;

			case 'integer':
				vld = vld.integer(validation.msg_en);
				break;

			case 'round':
				vld = vld.round(validation.method || 'round');
				break;

			case 'truncate':
				vld = vld.truncate();
				break;

			/* =====================================================
			   ARRAY
			===================================================== */

			case 'minItems':
				vld = vld.min(validation.value, validation.msg_en);
				break;

			case 'maxItems':
				vld = vld.max(validation.value, validation.msg_en);
				break;

			case 'ensure':
				vld = vld.ensure();
				break;

			case 'compact':
				vld = vld.compact(validation.rejector);
				break;

			case 'of':
				vld = vld.of(validation.schema);
				break;

			/* =====================================================
			   DATE
			===================================================== */

			case 'minDate':
				vld = vld.min(validation.value, validation.msg_en);
				break;

			case 'maxDate':
				vld = vld.max(validation.value, validation.msg_en);
				break;

			/* =====================================================
			   OBJECT
			===================================================== */

			case 'shape':
				vld = vld.shape(validation.fields);
				break;

			case 'noUnknown':
				vld = vld.noUnknown(validation.value ?? true, validation.msg_en);
				break;

			/* =====================================================
			   CUSTOM
			===================================================== */

			case 'test':
				vld = vld.test(
					validation.name || 'custom-test',
					validation.msg_en,
					validation.testFn
				);
				break;

			case 'validate':
				if (typeof validation.callback === 'function') {
					vld = vld.test(
						validation.name || 'custom-validate',
						validation.msg_en || 'Validation failed',
						function (value) {
							const rowObj = this.options.context?.row || {
								original: this.parent,
								origin: this.parent,
								_valuesCache: this.parent
							};
							return validation.callback(value, this.parent, rowObj);
						}
					);
				}
				break;

			/* =====================================================
			   CONDITIONAL
			===================================================== */

			case 'when':
				return vld.when(validation.relation, {
					is: (val: any) =>
						typeof validation.is === 'function'
							? validation.is(val)
							: Array.isArray(validation.values)
								? validation.values.includes(val)
								: val === validation.values,

					then: (s: any) =>
						validation?.thenValidations?.reduce(
							(acc: any, v: any) =>
								validationReducer(acc, v, column),
							s
						) || s,

					otherwise: (s: any) =>
						validation?.otherWiseValidations?.reduce(
							(acc: any, v: any) =>
								validationReducer(acc, v, column),
							s
						) || s,
				});

			default:
				break;
		}

		return vld;
	};



	const generateValidationSchema = (columns: any[]) => {
		return columns.reduce((acc: any, clm: any) => {
			const validations = clm?.editProperties?.validations;

			if (!validations?.length) return acc;

			const baseSchema = getValidationType(clm);

			acc[clm.accessorKey] = validations.reduce(
				(schema: any, validation: any) =>
					validationReducer(schema, validation, clm),
				baseSchema
			);

			return acc;
		}, {});
	};


	useEffect(() => {
		setTableColumns(columns);

		const schema: any = generateValidationSchema(columns);
		setValidationSchema(yup.object().shape(schema));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [columns]);

	useEffect(() => {
		if (!columnSizingInfo?.isResizingColumn) {
			updatePageInfo({ column_sizes: { ...activePage.column_sizes, ...columnSizing } })
			handleColumnResizing?.(columnSizing)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [columnSizingInfo?.isResizingColumn, columnSizing])

	const handleHeaderClick = (event: any) => {
		setAnchorEl(event.currentTarget);
	};

	const handleHeaderClose = () => {
		setAnchorEl(null);
	};

	const handleVisibleColumn = (column: any) => {
		const updatedColumns = tableColumns.map((col: any) => ({
			...col,
			visible: col.accessorKey === column.accessorKey ? false : col.visible
		}));
		setTableColumns(updatedColumns);
		onColumnVisibility?.(JSON.parse(JSON.stringify(updatedColumns)))
		setFilteredOptions([...filteredOptions, column]);
		setAnchorEl(null);
	};

	const handleAddButtonClick = () => {
		setPopupShow(true);
	};

	const handleBackButtonClick = () => {
		setPopupShow(false);
	};

	const handleAddColumn = (column: any) => {
		const updatedColumns = tableColumns.map((col: any) => ({
			...col,
			visible: col.accessorKey === column.accessorKey ? true : col.visible
		}));
		onColumnVisibility?.(JSON.parse(JSON.stringify(updatedColumns)))
		setTableColumns(updatedColumns);

		const updatedFilteredOptions = filteredOptions.filter(
			(option: any) => option.accessorKey !== column.accessorKey
		);
		setFilteredOptions(updatedFilteredOptions);
		setAnchorEl(null);
		setPopupShow(false);
	};

	const handleSearchEvent = (searchQuery: string) => {
		const filteredColumns = hiddenColumns.filter((option: any) =>
			option.header.toLowerCase().includes(searchQuery.toLowerCase())
		);
		setFilteredOptions(filteredColumns);
	};

	const handleCustomAddColumn = () => {
		navigate(path, { state: formData })
		setAnchorEl(null);
		setPopupShow(false);
	};

	const handleRowClick = (rowId: number) => {
		setSelectedRow(rowId); // Update selected row ID when a row is clicked
	};

	// const handleDeleteClick = (event: any, data: any) => {
	//   onDelete?.(data.id);
	// };
	// const handleUpdateClick = (event: any, data: any) => {
	//   onUpdate?.(data.id);
	// };

	const handleActionsClick = (event: any, data: any) => {
		setRow(data);
		setRowAnchorEl(event.currentTarget);
	};

	const handleActionsClose = () => {
		setRowAnchorEl(null);
	};

	const formtValues = useCallback((values: any, cells: any[]) => {
		const v: any = {};
		if (values?.['mrt-row-actions']) {
			delete values['mrt-row-actions']
		}
		Object.keys(values).forEach((vl) => {
			const val = values[vl];
			const cell = cells.find((c) => c.accessorKey == vl);

			if (val) {
				if (val instanceof File) {
					v[vl] = val.name;
				} else if (cell && cell?.editVariant == 'date') {
					v[vl] = dayjs(val).format(cell?.dateFormat || 'DD-MM-YYYY');
				} else if (cell && cell?.editVariant == 'time') {
					v[vl] = dayjs.isDayjs(val) ? val.format('HH:mm') : val;
				} else if (cell && cell?.editVariant == 'select' && typeof val === 'object' && val !== null) {
					// For select fields, extract the display name from the object
					// Try multiple possible display properties in order of preference
					v[vl] = val.name || val.label || val.display_name || val.title || val.value || val.id || val;
				} else if (cell && cell?.editVariant == 'select' && typeof val === 'string') {
					// For select fields that are already strings, keep them as is
					v[vl] = val;
				} else {
					v[vl] = val;
				}
			} else {
				v[vl] = val;
			}
		});

		return v;
	}, []); // No dependencies needed as this function doesn't rely on external values

	const handleRowDelete = async () => {
		setIsDeletingRow(true);
		if (rowToDelete) {
			await onDeleteRow?.(rowToDelete);
			setRowToDelete(null);
		}
		setIsDeletingRow(false);
	};

	const checkRequired = useCallback((editProperties: any) => {
		return editProperties?.validations?.some((validation: any) => validation.type === 'required')
	}, [])
	useEffect(() => {
		const selectedRows = {};
		// Build the selectedRows object
		if (!isChecked && selectedRowIds.length) {
			rows.forEach((row) => {
				if (selectedRowIds.includes(row.id)) {
					selectedRows[row.id] = true;
				}
			});
			setRowSelection(selectedRows);
			setIsChecked(true)
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [rows, selectedRowIds]); // Dependency only on rows and selectedRowIds

	useEffect(() => {
		if (onSortingChange instanceof Function) {
			const sortingArray = Array.isArray(sorting) ? sorting : [];
			onSortingChange(sortingArray[0] || null)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [sorting])


	const resetRowSelection = () => {
		setRowSelection({});
		setDisableNextEdit(false)
	}
	const getTextWidth = (text: string) => {
		const canvas = document.createElement("canvas");
		const ctx = canvas.getContext("2d");
		if (!ctx) return 50;
		return ctx.measureText(text).width + 5; // padding
	}

	// ─── Types ───────────────────────────────────────────────────────────────────

	type RowMode = 'edit' | 'create';

	interface SaveRowParams {
		row: MRT_Row<TData>;
		values: Record<string, unknown>;
		table: MRT_TableInstance<TData>;
	}

	// ─── Shared validation error extractor ───────────────────────────────────────

	const extractValidationErrors = (err: yup.ValidationError): Record<string, string> =>
		err.inner.reduce<Record<string, string>>((acc, { path, message }) => {
			if (path) acc[path] = message;
			return acc;
		}, {});

	// ─── Unified save handler ─────────────────────────────────────────────────────

	const handleSaveRow = useCallback(
		async ({ row, values, table }: SaveRowParams, mode: RowMode): Promise<void> => {
			const isEditMode = mode === 'edit';
			const setLoadingState = isEditMode ? setIsEditingRow : setIsCreatingRow;
			const rowId = row.id;

			try {
				await validationSchema.validate(values, { abortEarly: false, context: { row } });

				setValidationErrors((prev) => { const next = { ...prev }; delete next[rowId]; return next; });
				setLoadingState(true);
				setDisableNextEdit(false);

				const cells = row.getAllCells().map((c) => c.column.columnDef);
				row._valuesCache = formtValues(values, cells);

				const data = { row, values, table };

				if (isEditMode) {
					await onEditRow?.(data, 'edit');
					table.setEditingRow(null);
				} else {
					await onCreateRow?.(data);
					table.setCreatingRow(null);
				}
			} catch (err) {
				if (err instanceof yup.ValidationError) {
					const fieldErrors = err.inner.reduce<Record<string, string>>((acc, { path, message }) => {
						if (path) acc[path] = message;
						return acc;
					}, {});
					setValidationErrors((prev) => ({ ...prev, [rowId]: fieldErrors }));
				} else {
					enqueueSnackbar(
						getErrorMessage(err instanceof Error ? err.message : 'Something went wrong'),
						{ variant: 'error' },
					);
				}
			} finally {
				setLoadingState(false);
			}
		},
		[validationSchema, onEditRow, onCreateRow, formtValues],
	);

	const validate = useCallback(async (values: any, row?: any) => {
		try {
			await validationSchema.validate(values, { abortEarly: false, context: { row } });
			setValidationErrors({});
			return true;
		} catch (err) {
			return false
		}
	}, [validationSchema]);

	const validateField = useCallback(
		async (columnId: string, value: any, rowId: string, rowValues: any) => {
			if (!validationSchema || typeof validationSchema.validateAt !== 'function' || !validationSchema.fields || !validationSchema.fields[columnId]) return;
			try {
				await validationSchema.validateAt(
					columnId,
					{
						...rowValues,
						[columnId]: value,
					},
					{
						abortEarly: false,
					}
				);
				setValidationErrors((prev) => {
					const next = { ...prev };
					if (next[rowId]) {
						const rowErrs = { ...next[rowId] };
						delete rowErrs[columnId];
						next[rowId] = rowErrs;
					}
					return next;
				});
			} catch (err) {
				if (err instanceof yup.ValidationError) {
					const fieldErrors = err.inner.reduce<Record<string, string>>((acc, { path, message }) => {
						if (path) acc[path] = message;
						return acc;
					}, {});
					setValidationErrors((prev) => ({
						...prev,
						[rowId]: {
							...(prev[rowId] ?? {}),
							...fieldErrors,
						},
					}));
				}
			}
		},
		[validationSchema],
	);

	const valuesRef = useRef<Record<string, RowValues>>({});

	// ─── Public API: sync one field ────────────────────────────────────────────
	const syncFieldValue = useCallback(
		(rowId: string, columnId: string, value: unknown) => {
			valuesRef.current[rowId] = {
				...(valuesRef.current[rowId] ?? {}),
				[columnId]: value,
			};
		},
		[],
	);

	const clearRow = useCallback((rowId: string) => {
		delete valuesRef.current[rowId];
	}, []);

	// ─── Merge our cache on top of MRT's cache then the original row ───────────
	const getRowValues = useCallback(
		(row: MRT_Row<TData>): RowValues => ({
			// 1. original row data — baseline
			...(row.original as RowValues),
			// 2. MRT's internal cache — contains what MRT-controlled fields wrote
			...(row._valuesCache as RowValues | undefined),
			// 3. Our own cache — authoritative for custom fields
			...(valuesRef.current[row.id] ?? {}),
		}),
		[],
	);

	// ─── Save helpers (kept stable across renders) ─────────────────────────────
	const saveEditingRow = useCallback(
		async (table: MRT_TableInstance<TData>) => {
			const editingRow = table.getState().editingRow;
			const creatingRow = table.getState().creatingRow;
			if (!editingRow) return;
			const values = getRowValues(editingRow);
			const isValid = await validate(values, editingRow);
			if (!isValid) {
				// Let handleSaveRow set the validation errors for display
				await handleSaveRow({ row: editingRow, values, table }, 'edit');
				return;
			}
			await handleSaveRow({ row: editingRow, values, table }, 'edit');
			clearRow(editingRow.id);
			if (!creatingRow && enableRowCreate) {
				setDisableNextEdit(false)
				setTimeout(() => table.setCreatingRow(true), 200);
			} else {
				setDisableNextEdit(false);
			}
		},
		[getRowValues, handleSaveRow, clearRow, validate, enableRowCreate],
	);

	const saveCreatingRow = useCallback(
		async (table: MRT_TableInstance<TData>) => {
			const creatingRow = table.getState().creatingRow;
			if (!creatingRow) return;
			const values = getRowValues(creatingRow);
			if (values?.['mrt-row-actions']) {
				delete values['mrt-row-actions']
			}
			const isValid = await validate(values, creatingRow);
			await handleSaveRow({ row: creatingRow, values, table }, 'create');
			if (!isValid) return;
			if (isValid) {
				setDisableNextEdit(false)
				clearRow('mrt-row-create');
				setTimeout(() => table.setCreatingRow(true), 200);
			}
		},
		[getRowValues, clearRow, validate],
	);

	const table = useMaterialReactTable({
		// options:{
		// 	tableLayout: "auto", // 👈 important
		// 	padding: "dense",
		// },
		// columns: visibleColumns,
		defaultColumn: {
			minSize: 0,   // 👈 remove default min width
			size: undefined,     // 👈 optional, default size
		},
		columns: [
			...visibleColumns.map((c: any) => {
				const headerWidth = getTextWidth(c.header || '');
				const maxCellWidth = Math.max(
					...rows.map(row => getTextWidth(String(row[c.accessorKey] ?? '')))
				);
				const finalWidth = Math.max(headerWidth, maxCellWidth);
				return {
					...c,
					...(editDisplayMode === 'row'
						? {
							Edit: ({ cell, row, table, column }) => {
								return (
									<InlineEditFields
										cell={cell}
										column={column}
										col={c}
										row={row}
										table={table}
										callback={(s) => console.log('Save', s)}
										errors={validationErrors[row.id] ?? {}}
										validationSchema={validationSchema}
										setValidationErrors={(errors: Record<string, string>) =>
											setValidationErrors((prev) => ({ ...prev, [row.id]: errors }))
										}
										onChangeRowField={onChangeRowField}
										getSelectedData={(name, row) => getSelectedData?.(name, row)}
										syncFieldValue={syncFieldValue}
									/>
								);
							},
						}
						: {}),
					Header: (
						<Box display='flex' alignItems='center'>
							{c.header}
							{c?.required || checkRequired(c?.editProperties) && (
								<Typography type='s5' color='theme.error.600'>
									*
								</Typography>
							)}
						</Box>
					),
					enableColumnDragging: c.id !== 'actions',
					// cellStyle: { ...c.cellStyle, width: finalWidth },
					// headerStyle: { ...c.headerStyle, width: finalWidth },
					// size: finalWidth
					size: undefined,
					// minSize: 40,
					maxSize: 800,
				};
			}),
			...(!disableDefaultActionColumn
				? [
					{
						id: 'actions',
						enableEditing: false,
						size: defaultActionColumnItems?.length > 1 ? 80 : 50,
						header: (
							<IconButton size="small" sx={{ p: 0.5, '&:hover': { backgroundColor: 'transparent' } }} onClick={handleHeaderClick}>
								<img src={images.common.arrowIcon} alt='Arrow Icon' />
							</IconButton>
						),
						enableColumnDragging: false,
						visible: true,
						muiTableHeadCellProps: {
							className: 'pinned-column'
						},
						muiTableBodyCellProps: {
							className: 'pinned-column',
							sx: {
								whiteSpace: 'pre-wrap'
							}
						},
						Cell: (props) =>
							defaultActionColumnItems?.length ? (
								defaultActionColumnItems.map((item) => {
									const updatedProps = {
										...item.props,
										onClick: () => item.props.onClick(props)
									};
									return cloneElement(item, updatedProps);
								})
							) : !disabledDefaultActionColumnIcon && (
								<IconButton
									onClick={(e) => handleActionsClick(e, props.row.original)} disabled={!rowActionMenu?.length && !destructiveActionMenu?.length}>
									<img src={images.more} alt='More Icon' />
								</IconButton>
							)
					}
				]
				: [])
		],
		data: rows,
		muiTablePaperProps: {
			sx: {
				tableLayout: 'auto', // lets columns shrink to fit content
			},
		},
		columnResizeMode: 'onChange',
		onEditingRowSave: async (data) => {
			await handleSaveRow(data, 'edit');
		},
		onCreatingRowSave: async (data) => {
			await handleSaveRow(data, 'create');
		},
		onCreatingRowCancel: () => resetRowSelection(),
		onEditingRowCancel: () => {
			setDisableNextEdit(false);
		},
		onSortingChange: states?.sorting ? onSortingChange : setSorting,

		displayColumnDefOptions: {
			'mrt-row-actions': {
				// size: onDeleteRow ? 80 : 50,

				Header: (
					<IconButton onClick={handleHeaderClick} size='small'>
						<img src={images.common.arrowIcon} alt='Arrow Icon' />
					</IconButton>
				),
				muiTableBodyCellProps: ({ row, table }) => {
					const isCreatingRow = table.getState().creatingRow?.id === row.id;
					const isEditingRow = table.getState().editingRow?.id === row.id;
					return {
						sx: {
							'& .MuiBox-root': {
								gap: 0
							},
							backgroundColor: '#fff',
							whiteSpace: 'pre-wrap',
							// Hide save button only when editing existing row (not in create mode or non-editable mode)
							...((hideSaveButton && (isEditingRow || isCreatingRow))
								? {
									'& .MuiBox-root > .MuiIconButton-root:first-of-type': {
										display: 'none !important'
									},
									// Also hide any save icon buttons by aria-label or title
									'& button[aria-label*="Save"]': {
										display: 'none !important'
									},
									'& button[title*="Save"]': {
										display: 'none !important'
									},
									// Hide save icon by class or data attributes
									'& .MuiIconButton-root[class*="save"]': {
										display: 'none !important'
									},
									'& .MuiIconButton-root[data-testid*="save"]': {
										display: 'none !important'
									}
								}
								: {})
						},
					};
				}
			},
			'mrt-row-expand': {
				size: 70, // Set the size of the expand-collapse arrow column here
			},
			'mrt-row-select': {
				size: 50, // Set the width of the checkbox column here
			},
		},
		renderRowActions: ({ row, table }) => (
			<>
				{rest?.enableExpanding ? (
					<>
						{row?.parentId && (
							<Box sx={{ display: 'flex', gap: 0 }}>
								{onDeleteRow && !hideDeleteButton?.(row.original) && (
									<Tooltip title='Delete'>
										<IconButton disabled={disableNextEdit} onClick={() => setRowToDelete(row)} size='small' className='delete-row'>
											<Trash fontSize='small' sx={{ color: 'theme.secondary.1000' }} />
										</IconButton>
									</Tooltip>
								)}
							</Box>
						)}
					</>
				) : (
					<Box sx={{ display: 'flex', gap: 0 }}>
						{onDeleteRow && !hideDeleteButton?.(row.original) && (
							<Tooltip title='Delete'>
								<IconButton disabled={disableNextEdit} onClick={() => setRowToDelete(row)} className='delete-row'>
									<Trash fontSize='small' sx={{ color: 'theme.secondary.1000' }} />
								</IconButton>
							</Tooltip>
						)}
					</Box>
				)}
			</>
		),

		...(Boolean(enableRowCreate) && {
			renderBottomToolbarCustomActions: ({ table }) => (
				<Button
					variant='outlined'
					startIcon={<Add />}
					className='add-row-btn'
					disabled={disableNextEdit}
					onClick={() => {
						table.setCreatingRow(true); //simplest way to open the create row modal with no default values
						setDisableNextEdit(true)
					}}>
					{t('common.add')}
				</Button>
			)
		}),
		onRowSelectionChange: setRowSelection,
		enableColumnOrdering: true,
		enableRowSelection: enableRowSelection ?? true,
		enableEditing: (row) => enableEditing instanceof Function ? enableEditing(row) : enableEditing ?? true,
		editDisplayMode: editDisplayMode ?? 'row',
		createDisplayMode: 'row',
		positionCreatingRow: 'bottom',
		enableColumnResizing: enableColumnResizing,
		enableRowDragging: enableRowDragging,
		enableTopToolbar: false,
		enableColumnActions: false,
		enableSorting: true,
		enableGrouping: true,
		enableBottomToolbar: enableBottomToolbar ?? false,
		enableColumnDragging: enableColumnDragging ?? true,
		enableStickyHeader: true,
		enableSortingRemoval: false,
		// column ordering
		state: {
			// columnOrder: (!columnOrder || columnOrder.length <= 1) 
			// ? [...internalColumnOrder] 
			// : [...columnOrder],
			columnOrder: columnOrder,
			columnPinning: { left: ['actions', 'mrt-row-actions'] },
			isSaving: isCreatingRow || isEditingRow,
			showProgressBars: false,
			rowSelection,
			...states,
			sorting: Array.isArray(states?.sorting) ? states?.sorting :
				Array.isArray(sorting) ? sorting : [],
			columnSizing

		},
		getRowId: (row) => row?.id,
		// table.getState().editingRow
		muiTableBodyRowProps: ({ row, table }) => {
			const editingRowId =
				table.getState()?.editingRow?.id ||
				table.getState()?.creatingRow?.id ||
				null;
			const creatingRowId = table.getState()?.creatingRow?.id || null;
			const isErrorRow = Boolean(row?.original?.has_error)
			const isCurrentlyEditing = editingRowId === row.id;

			return {
				onClick: () => {
					setSelectedRow(row.id);
					// Edit triggering is now handled at cell level in muiTableBodyCellProps
					// to support isOnClickEditable column prop
				},
				sx: {
					cursor: 'pointer',
					// backgroundColor: !editingRowId
					// 	? (selectedRow === row.id
					// 		? '#e8e8e8'
					// 		: (isErrorRow ? 'theme.error.100' : 'inherit'))
					// 	: 'inherit',
					backgroundColor: !editingRowId
						? (isErrorRow ? 'theme.error.100' : 'inherit')
						: 'inherit',
					'&:hover': {
						backgroundColor: editingRowId
							? (editingRowId === row.id ? 'transparent' : 'inherit')
							: (isErrorRow ? 'theme.error.200' : '#e8e8e8')
					},
					'&:hover td:after': {
						backgroundColor: 'transparent' // Removes the grey background applied via :after
					}
				}
			};
		},
		onColumnOrderChange: (colOrder: any) => {
			if (handleColumnOrdering) handleColumnOrdering(colOrder);
		},
		onColumnSizingChange: setColumnSizing,
		onColumnSizingInfoChange: setColumnSizingInfo,

		renderEmptyRowsFallback: () => (
			<Box className='no-data'>
				<img src={images.common.tableNoData} />
				<Typography type='s3' weight='medium' color='theme.secondary.1000'>
					{/* sx={{ textAlign: 'center', pb: 4.75, pt: 4.75 }}> */}
					{t('common.noData')}
				</Typography>
			</Box>
		),

		// pagination
		enablePagination: enablePagination,
		paginationDisplayMode: 'pages',
		muiPaginationProps: {
			shape: 'rounded',
			page: pageNo, // current page number
			count: totalPages, // total pages
			showRowsPerPage: false, // Hide rows per page options
			boundaryCount: 3
		},

		muiEditTextFieldProps: ({ row, column }) => ({
			InputProps: {
				disableUnderline: true
			},
			onBlur: (e) => {
				updateData(e.target.value, column, row.id);
			},
			// onChange: (e) => {
			// 	updateData(e.target.value, column, row.id);
			// },
			variant: 'outlined',
			sx: ({ palette }) => ({
				'& .MuiOutlinedInput-root': {
					'& fieldset': {
						borderColor: `${palette.theme?.primary[700]} !important`
						// backgroundColor: palette.theme?.primary[700]
					}
				}
			})
		}),

		/* Table loader style */
		muiCircularProgressProps: {
			sx: {
				color: '#289B64'
			}
		},

		// Table header cell default styles
		muiTableHeadCellProps: {
			sx: {
				lineHeight: '140%',
				letterSpacing: '-0.28px',
				fontWeight: '500',
				fontSize: '0.875rem',
				'& .Mui-TableHeadCell-Content': {
					height: '100%'
				},
				'& .Mui-TableHeadCell-Content-Labels': {
					width: '100%',
					justifyContent: 'space-between'
				},
				'&.pinned-column': {
					backgroundColor: '#fff'
				},
				'& .Mui-TableHeadCell-ResizeHandle-Wrapper': {
					padding: 0,
					margin: 0,
					right: '-5px',
					opacity: 0
				},
			}
		},

		// Table body cell default styles
		muiTableBodyProps: {
			sx: {
				zIndex: 500
			}
		},
		muiTableHeadProps: {
			sx: {
				zIndex: 600
			}
		},
		muiTableBodyCellProps: ({ cell, column, table, row }) => ({
			sx: {
				lineHeight: '140%',
				letterSpacing: '-0.26px',
				fontWeight: '400',
				fontSize: '0.8125rem',
				'&.pinned-column': {
					backgroundColor: '#fff'
				},
				'&:hover': {
					backgroundColor: 'transparent' // Removes hover effect globally
				},
				whiteSpace: 'pre-wrap'
			},
			onClick: (e: React.MouseEvent) => {
				const target = e.target as HTMLElement;

				// Check if click is inside table
				// const isInsideTable = target.closest('.MuiTableContainer-root, .MuiPaper-root, .MRT_Table');
				const tableCell = target.closest('.MuiTableCell-body');

				const isInsideTable = tableCell && !tableCell.querySelector('.delete-row');

				if (!isInsideTable) return; // Ignore clicks outside table or on delete button

				const columnDef = column.columnDef as MaterialEditableTableColumnProps;
				const isOnClickEditable = columnDef.isOnClickEditable !== false; // Default to true

				if (!isOnClickEditable) {
					return; // Don't trigger edit mode for this column
				}

				const editingRowId = table.getState()?.editingRow?.id || table.getState()?.creatingRow?.id || null;
				const isCurrentlyEditing = editingRowId === row.id;

				// If another row is already in edit/create mode, save it first then edit this row
				if (editingRowId && editingRowId !== row.id) {
					const currentEditingRow = table.getState().editingRow;
					const currentCreatingRow = table.getState().creatingRow;

					(async () => {
						let saveSucceeded = false;
						if (currentCreatingRow) {
							const values = getRowValues(currentCreatingRow);
							const isValid = await validate(values, currentCreatingRow);
							if (!isValid) return; // stay on current row if invalid
							await handleSaveRow({ row: currentCreatingRow, values, table }, 'create');
							clearRow('mrt-row-create');
							saveSucceeded = true;
						} else if (currentEditingRow) {
							const values = getRowValues(currentEditingRow);
							const isValid = await validate(values, currentEditingRow);
							if (!isValid) return; // stay on current row if invalid
							await handleSaveRow({ row: currentEditingRow, values, table }, 'edit');
							clearRow(currentEditingRow.id);
							saveSucceeded = true;
						}
						if (saveSucceeded) {
							table.setEditingRow(row);
							setDisableNextEdit(true);
						}
					})();
					return;
				}

				// Set the row as editable when clicked if not already editing and no other row is being edited
				if (!isCurrentlyEditing && !editingRowId) {
					table.setEditingRow(row);
					setDisableNextEdit(true);
				}
			},
			onKeyUp: (e: React.KeyboardEvent) => {
				const creatingRowId =
					table.getState().creatingRow?.id ?? null;

				// ── Escape ──────────────────────────────────────────────────────────
				if (e.key === 'Escape') {
					if (creatingRowId === row.id) {
						clearRow('mrt-row-create');
						table.setCreatingRow(null);
					} else {
						const editingRow = table.getState().editingRow;
						if (editingRow) {
							clearRow(editingRow.id);
							table.setEditingRow(null);
						}
					}
					setDisableNextEdit(false);
					setValidationErrors({});
					e.preventDefault();
					e.stopPropagation();
					return;
				}

				// ── Enter ───────────────────────────────────────────────────────────
				if (e.key === 'Enter') {
					// Minimal timeout: let the last field onChange flush its state.
					// Our valuesRef is already written, so 0ms is safe.
					setTimeout(() => {
						const currentCreatingRow = table.getState().creatingRow;
						const currentEditingRow = table.getState().editingRow;

						if (currentCreatingRow) {
							saveCreatingRow(table);
						}

						if (currentEditingRow) {
							saveEditingRow(table);
						}
					}, 0); // 0 ms is enough — values are already in valuesRef
				}
			},
		}),

		// Checkbox styling
		muiSelectCheckboxProps: {
			sx: {
				color: 'theme.secondary.300',
				'&.Mui-checked': {
					color: 'theme.primary.600',
					'&:hover': {
						color: 'theme.primary.500'
					}
				},
				'&.Mui-disabled': {
					color: 'theme.secondary.200'
				}
			},
			icon: <RecgtangleIcon sx={{ width: 20, height: 20 }} />,
			checkedIcon: <CheckBoxIcon sx={{ width: 20, height: 20 }} />
		},
		muiSelectAllCheckboxProps: {
			sx: {
				color: 'theme.secondary.300',
				'&.Mui-checked': {
					color: 'theme.primary.600',
					'&:hover': {
						color: 'theme.primary.500'
					}
				},
				'&.Mui-disabled': {
					color: 'theme.secondary.600'
				}
			},
			icon: <RecgtangleIcon sx={{ width: 20, height: 20 }} />,
			checkedIcon: <CheckBoxIcon sx={{ width: 20, height: 20 }} />
		},
		muiBottomToolbarProps: {
			sx: {
				boxShadow: 'none',
				'& .MuiBox-root': {
					paddingLeft: 0
				}
			}
		},

		layoutMode: 'grid',
		icons: {
			DragHandleIcon: () => <RecgtangleIcon fontSize='medium' />,
			SortIcon: () => <ArrowUpDown fontSize='medium' />,
			ArrowDownwardIcon: () => <ArrowUpDown fontSize='medium' />,
			ArrowUpwardIcon: () => <ArrowUpDown fontSize='medium' />,
			ExpandMoreIcon: () => <ArrowUpDown fontSize='medium' />,
			ExpandLessIcon: () => <ArrowUpDown fontSize='medium' />,
			SyncAltIcon: () => <ArrowUpDown fontSize='medium' />,
			CancelIcon: (props: SvgIconProps) => (
				<Close fontSize='small' {...props} color='theme.secondary.1000' />
			)
		},

		...rest
	});

	useEffect(() => {
		if (enableRowSelection) {
			if (table?.getSelectedRowModel()?.rows) {
				SetSelectedRowId?.(table?.getSelectedRowModel()?.rows);
			}
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [enableRowSelection]);

	useEffect(() => {
		if (onSelectRow) {
			if (rest?.enableExpanding) {
				const selectedRowModels: any[] = [];
				const selection = table.getState().rowSelection; // e.g., { 0.0: true }
				const traverseRows = (rows, parentKey = '') => {
					rows.forEach((row: any, index: number) => {
						const rowKey = parentKey ? `${parentKey}.${index}` : `${row.id}`;
						if (selection[rowKey]) {
							selectedRowModels.push(row);
						}

						// Check for sub-rows and traverse further
						if (row.subRows?.length) {
							traverseRows(row.subRows, rowKey);
						}
					});
				};

				traverseRows(table.getRowModel().rows);
				onSelectRow(selectedRowModels, rowSelection);
			} else {
				onSelectRow(table.getSelectedRowModel().rows, rowSelection);
			}

		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [rowSelection, table]);

	// useEffect(() => {
	// 	const relativeContainer = document.getElementsByClassName(
	// 		'MuiTableContainer-root'
	// 	)[0];
	// 	const fixedElement = document.getElementsByClassName('no-data')[0];
	// 	relativeContainer.addEventListener('scroll', () => {
	// 		const scrollLeft = relativeContainer.scrollLeft;
	// 		fixedElement.style.left = `${scrollLeft + 100}px`;
	// 	});
	// }, []);

	useEffect(() => {
		if (isResetRow) {
			table?.resetRowSelection();
		}
	}, [isResetRow, table]);

	// Auto-open first row in edit mode when enableFirstRowEdit is true
	const hasAutoEditedFirstRow = useRef(false);
	useEffect(() => {
		if (
			enableFirstRowEdit &&
			!hasAutoEditedFirstRow.current &&
			rows?.length > 0
		) {
			// Get a fresh row reference from the current table model
			const tableRows = table.getRowModel().rows;
			const firstRow = tableRows[0];
			if (firstRow) {
				hasAutoEditedFirstRow.current = true;
				// Pre-initialize _valuesCache from original data so InlineEditFields
				// has a populated cache from the start
				if (!firstRow._valuesCache || Object.keys(firstRow._valuesCache).length === 0) {
					firstRow._valuesCache = { ...firstRow.original };
				}
				table.setEditingRow(firstRow);
				setDisableNextEdit(true);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [enableFirstRowEdit, rows, table]);

	// Handle clicks outside the table to save and exit edit mode - ADVANCED EVENT DELEGATION
	useEffect(() => {
		if (!table) return;

		let dropdownOpenTimer: NodeJS.Timeout;
		let saveTimer: NodeJS.Timeout;
		let lastDropdownClick = 0;
		let isDropdownInteraction = false;

		// Track dropdown interactions with precise timing
		const handleMouseDown = (e: MouseEvent) => {
			const target = e.target as HTMLElement;
			const isDropdownElement = target.closest(
				'.MuiSelect-root, .MuiMenuItem-root, .MuiPopover-root, .MuiList-root, ' +
				'.MuiMenu-list, .MuiButtonBase-root, ' +
				'.MuiFormControl-root, .MuiInputBase-root, .MuiTextField-root, ' +
				'.MuiOutlinedInput-root, .MuiFilledInput-root, .MuiAutocomplete-popper, ' +
				'.MuiPickersPopper-root, [role="option"], [role="listbox"], [role="combobox"]'
			);

			if (isDropdownElement) {
				isDropdownInteraction = true;
				lastDropdownClick = Date.now();
				// Clear any pending save when dropdown interaction starts
				if (saveTimer) {
					clearTimeout(saveTimer);
				}
				// Set a timer to reset dropdown interaction flag
				if (dropdownOpenTimer) {
					clearTimeout(dropdownOpenTimer);
				}
				dropdownOpenTimer = setTimeout(() => {
					isDropdownInteraction = false;
				}, 500);
			}
		};

		// Handle clicks with sophisticated logic
		const handleClick = (e: MouseEvent) => {
			const editingRow = table.getState()?.editingRow;
			const creatingRow = table.getState()?.creatingRow;
			if (!editingRow && !creatingRow) return;

			const target = e.target as HTMLElement;
			const now = Date.now();

			// Don't process if we recently had a dropdown interaction
			if (isDropdownInteraction || (now - lastDropdownClick) < 300) {
				return;
			}

			// Check if click is inside table
			// const isInsideTable = target.closest('.MuiTableContainer-root, .MuiPaper-root, .MRT_Table');
			const isInsideTable = target.closest('.MRT-TableWrapper');

			// Only save if clicking outside table and no recent dropdown interaction
			if (!isInsideTable) {
				// Clear any existing save timer
				if (saveTimer) {
					clearTimeout(saveTimer);
				}

				// Schedule save with additional delay for safety
				saveTimer = setTimeout(async () => {
					const currentEditingRow = table.getState()?.editingRow;
					const currentCreatingRow = table.getState()?.creatingRow;
					if (isDropdownInteraction) return;
					if (currentCreatingRow) {
						const values = getRowValues(currentCreatingRow);
						await handleSaveRow({ row: currentCreatingRow, values, table }, 'create');
						clearRow('mrt-row-create');
						setDisableNextEdit(false);
						return;
					}
					if (currentEditingRow) {
						const values = getRowValues(currentEditingRow);
						await handleSaveRow({ row: currentEditingRow, values, table }, 'edit');
						clearRow(currentEditingRow.id);
						setDisableNextEdit(false);
					}
				}, 200);
			}
		};

		// Use both mousedown and click for comprehensive tracking
		document.addEventListener('mousedown', handleMouseDown, true);
		document.addEventListener('click', handleClick, true);

		return () => {
			document.removeEventListener('mousedown', handleMouseDown, true);
			document.removeEventListener('click', handleClick, true);
			if (dropdownOpenTimer) {
				clearTimeout(dropdownOpenTimer);
			}
			if (saveTimer) {
				clearTimeout(saveTimer);
			}
		};
	}, [table, handleSaveRow, getRowValues, clearRow]);
	return (
		<TableWrapper className='MRT-TableWrapper custom-table'>
			<MaterialReactTable table={table} />

			<Menu
				anchorEl={anchorEl}
				open={Boolean(anchorEl)}
				onClose={handleHeaderClose}
				className='add-role-drp'>
				{popUpShow ? (
					<div>
						<MenuItem
							onClick={handleBackButtonClick}
							className='role-drp-list add-column-title'>
							<ListItemIcon className='add-icon'>
								<ChevronLeftIcon />
							</ListItemIcon>
							<ListItemText className='title'>
								{t('common.addColumn_label')}
							</ListItemText>
						</MenuItem>
						<Divider flexItem sx={{ mt: '0.25rem !important', mb: '0.25rem !important' }} />
						<div className='searchbar-box-list'>
							<SearchBar
								placeholder={'Search User'}
								handleSearch={(e) => handleSearchEvent(e)}
							/>
						</div>
						<div className='all-attribute-title'>
							<Typography variant='body2' color='text.secondary'>
								{t('common.allAttributes_label')}
							</Typography>
						</div>
						{filteredOptions.map((column: any) => (
							<MenuItem
								key={column.accessorKey}
								onClick={() => handleAddColumn(column)}>
								<Typography color='theme.secondary.1000' type='s3'>
									{column.header}
								</Typography>
							</MenuItem>
						))}
						<Divider flexItem sx={{ mt: '0.25rem !important', mb: '0.25rem !important' }} />
						{
							enableAddCustomField && <MenuItem onClick={handleCustomAddColumn} className='role-drp-list'>
								<ListItemIcon className='add-icon'>
									<img src={images.common.addIcon} alt='Add Icon' />
								</ListItemIcon>
								<ListItemText className='title'>
									{t('common.addCustomField_label')}
								</ListItemText>
							</MenuItem>
						}
					</div>
				) : (
					<>
						{visibleColumns.map((column: any) => (
							<MenuItem
								key={column.accessorKey}
								onClick={() => handleVisibleColumn(column)}
								className='role-drp-list'>
								<ListItemIcon className='add-icon'>
									<img src={images.common.dotsIcon} alt='Add Icon' />
								</ListItemIcon>
								<ListItemText className='title'>{column.header}</ListItemText>
								<ListItemIcon className='eye-icon'>
									<img src={images.common.eyeIcon} alt='Eye Icon' />
								</ListItemIcon>
							</MenuItem>
						))}
						<Divider flexItem sx={{ mt: '0.25rem !important', mb: '0.25rem !important' }} />
						<MenuItem onClick={handleAddButtonClick} className='role-drp-list'>
							<ListItemIcon className='add-icon'>
								<img src={images.common.addIcon} alt='Add Icon' />
							</ListItemIcon>
							<ListItemText className='title'>
								{t('common.addColumn_label')}
							</ListItemText>
							<Typography
								variant='body2'
								color='text.secondary'
								className='eye-icon'>
								<ChevronRightIcon sx={{ fontSize: '1.25rem !important' }} />
							</Typography>
						</MenuItem>
					</>
				)}
			</Menu>

			<Menu
				anchorEl={rowAnchorEl}
				open={Boolean(rowAnchorEl)}
				onClose={handleActionsClose}>
				{rowActionMenu?.map((option: any) => {
					if (
						(option.label === 'Move' &&
							(row?.is_directory === true || row?.is_directory === 1)) ||
						(option.label === 'Download' &&
							(row?.is_directory === true ||
								row?.is_directory === 1 ||
								row?.drive?.is_directory === true ||
								row?.drive?.is_directory === 1))
					) {
						// return null;
					}
					return (
						<MenuItem
							onClick={async () => {
								await option.handleAction(row);
								setRowAnchorEl(null);
							}}
							disabled={
								typeof option.disabled === 'function'
									? option.disabled(row)
									: Boolean(option.disabled)
							}
							sx={{ alignItems: 'center', gap: 0.5 }}
						>
							{option?.icon}
							<Typography type='s4' color='inherit'>
								{typeof option.label === 'function' ? option.label(row) : option.label}
							</Typography>
						</MenuItem>
					);
				})}
				{destructiveActionMenu?.length > 0 &&
					<>
						<Divider flexItem sx={{ mt: '0.25rem !important', mb: '0.25rem !important' }} />
						<div className='dropdown-inner--DestructiveHeader'>
							{destructiveActionMenu?.map((option: any) => (
								<MenuItem
									onClick={() => {
										option.handleAction(row);
										setRowAnchorEl(null);
									}}
									className='dropdown-inner--DestructiveActions'
									disabled={
										typeof option.disabled === 'function'
											? option.disabled(row)
											: Boolean(option.disabled)
									}>
									<Typography type='s4' color='inherit'>
										{typeof option.label === 'function' ? option.label(row) : option.label}
									</Typography>
								</MenuItem>
							))}
						</div>
					</>
				}
			</Menu>
			<ConfirmPopUp
				open={Boolean(rowToDelete)}
				onClose={() => setRowToDelete(null)}
				onConfirm={() => handleRowDelete()}
				title='Delete Item'
				description={`Are you sure you want to delete entry ?`}
				loading={isDeletingRow}
			/>
		</TableWrapper>
	);
});

export { MaterialEditableTable };
export default MaterialEditableTable;